import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../../firebase-config";
import Account from "./Account";
import AdminAccount from "./AdminAccount";

/**
 * AccountRouter
 * 
 * Conditionally renders AdminAccount or regular Account based on user role.
 * 
 * Usage in App.js:
 * 
 * import AccountRouter from "./components/pages/AccountRouter";
 * 
 * <Route path="/account" element={
 *   <ProtectedRoute>
 *     <AccountRouter />
 *   </ProtectedRoute>
 * } />
 */
const AccountRouter = () => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  
  const auth = getAuth(app);
  const db = getFirestore(app);
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          console.log("User UID:", user.uid);
          const userDoc = await getDoc(doc(db, "users", user.uid));
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            console.log("User data:", userData);
            console.log("userRole:", userData.userRole);
            console.log("user_role:", userData.user_role);
            
            const userRole = userData.userRole || userData.user_role || 'standard';
            console.log("Resolved role:", userRole);
            console.log("Is admin?:", userRole === 'admin');
            
            setIsAdmin(userRole === 'admin');
          } else {
            console.log("User doc doesn't exist!");
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      }
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, [auth, db]);
  
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: '#0a0a0f',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#a0a0b0',
        fontSize: '16px',
      }}>
        Loading...
      </div>
    );
  }
  
  return isAdmin ? <AdminAccount /> : <Account />;
};

export default AccountRouter;